import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { StatusuriProiecteService } from '../statusuri-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { IStatusAddPayload, IStatusForm } from '../statusuri-proiecte.interface';

@Component({
    selector: 'app-add-statusuri-proiecte',
    templateUrl: './add-statusuri-proiecte.component.html',
    styleUrls: ['./add-statusuri-proiecte.component.scss']
})
export class AddStatusuriProiecteComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Arhivat', value: '1' },
        { key: 'Nearhivat', value: '0' },
    ];

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        color: new FormControl('', [Validators.required]),
        arhiva: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddStatusuriProiecteComponent>,
        private statusuriProiecteService: StatusuriProiecteService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, color, arhiva } = this.form.value as IStatusForm;
        const payload: IStatusAddPayload = {
            name,
            color,
            arhiva
        };

        this.statusuriProiecteService
            .addStatus(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
